import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import BusFormCreate from '../BusFormCreate';
import api3004 from '../../services/api3004';

/* ===== ESTILOS (mantidos originais) ===== */

const Title = styled.h1`
  font-size: 28px;
  margin-bottom: 20px;
  font-family: 'Arial', sans-serif;
  color: #333;
  text-align: center;
`;

const Wrapper = styled.div`
  overflow-x: auto;
  margin-top: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Thead = styled.thead`
  background-color: #151e3d;
  color: white;
`;

const Th = styled.th`
  padding: 10px;
  text-align: left;
`;

const Tr = styled.tr`
    color: ${({$ativo}) => ($ativo ? "gray" : "black")};
  border-bottom: 1px solid #d3d3d3;
`;

const Td = styled.td`
  padding: 10px;
`;

const Button = styled.button`
  margin: 2px;
  padding: ${({$smal}) => ($smal ? "3px 6px" : "6px 12px")};
  font-size: ${({$smal}) => ($smal ? "11px" : "14px")};
  cursor: pointer;
  border: 1px solid #007bff;
  border-radius: 6px;
  color: #007bff;
  background-color: transparent;
  white-space: nowrap;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: #007bff;
    color: white;
  }

  &:active {
    transform: scale(0.98);
    background-color: #0056b3;
  }
`;
/* ===== NOVOS BOTÕES (somente para ativar/inativar) ===== */

const ActivateButton = styled(Button)`
  border-color: #28a745;
  color: #28a745;
  min-width: 95px;

  &:hover {
    background-color: #28a745;
    color: white;
  }

  &:active {
    background-color: #1e7e34;
    border-color: #1e7e34;
  }
`;

const InactivateButton = styled(Button)`
  border-color: red;
  color: red;
  min-width: 95px;

  &:hover {
    background-color: red;
    color: white;
  }

  &:active {
    background-color: darkred;
    border-color: darkred;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const FilterInput = styled.input`
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  min-width: 250px;
`;

const Centered = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

/* ===== COMPONENTE ===== */

const BusList = () => {
  const [onibus, setOnibus] = useState([]);
  const [editingOnibus, setEditingOnibus] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [filtroNome, setFiltroNome] = useState('');
  const [error, setError] = useState(null);

  const fetchOnibus = async () => {
    try {
      const token = localStorage.getItem('token');

      const response = await api3004.get('/api/onibus', {
        headers: { Authorization: `Bearer ${token}` },
      });

      setOnibus(response.data);
    } catch (error) {
      setError(error.response?.data?.error || 'Erro ao buscar ônibus');
    }
  };

  useEffect(() => {
    fetchOnibus();
  }, []);

  const toggleAtivo = async (id, ativoAtual) => {
    try {
      const token = localStorage.getItem('token');
      const novoValor = ativoAtual === 1 ? 0 : 1;

      await api3004.put(
        `/api/onibus/${id}`,
        { ativo: novoValor },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      fetchOnibus();
    } catch (error) {
      setError(error.response?.data?.error || 'Erro ao alterar status');
    }
  };

  const listaFiltrada = onibus.filter(o =>
    filtroNome
      ? o.nome?.toLowerCase().includes(filtroNome.toLowerCase())
      : true
  );

  return (
    <div>
      <Title>Ônibus</Title>

      <Centered>
        <Button onClick={() => setShowCreateModal(true)}>
          Cadastrar Ônibus
        </Button>

        <FilterInput
          placeholder="Filtrar por nome"
          value={filtroNome}
          onChange={(e) => setFiltroNome(e.target.value)}
        />
      </Centered>

      {error && (
        <p style={{ color: 'red', textAlign: 'center' }}>
          {error}
        </p>
      )}

      <Wrapper>
        <Table >
          <Thead>
            <tr>
              <Th>Prefixo / Placa</Th>
              <Th></Th>
            </tr>
          </Thead>
          <tbody>
            {listaFiltrada.map((o) => (
              <Tr key={o.id} $ativo={o.ativo}>
                <Td>{o.prefixo} / {o.placa}</Td>
                <Td>
                  <Button onClick={() => setEditingOnibus(o)}>
                    Editar
                  </Button>

                  {o.ativo === 1 ? (
                    <InactivateButton
                      onClick={() => toggleAtivo(o.id, o.ativo)}
                    >
                      Inativo
                    </InactivateButton>
                  ) : (
                    <ActivateButton
                      onClick={() => toggleAtivo(o.id, o.ativo)}
                    >
                      Ativo
                    </ActivateButton>
                  )}
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </Wrapper>

      {/* Modal Editar */}
      {editingOnibus && (
        <ModalOverlay>
          <BusFormCreate
            onClose={() => setEditingOnibus(null)}
            onCreated={fetchOnibus}
            onibus={editingOnibus}
          />
        </ModalOverlay>
      )}

      {/* Modal Criar */}
      {showCreateModal && (
        <ModalOverlay>
          <BusFormCreate
            onClose={() => setShowCreateModal(false)}
            onCreated={fetchOnibus}
          />
        </ModalOverlay>
      )}
    </div>
  );
};

export default BusList;